export default __webpack_public_path__ + "static/media/ic_wallet_16.d48eea93.svg";